import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { computed } from 'vue'
import { Info } from 'lucide-vue-next'

interface Props {
  text?: string
  position?: 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  showArrow?: boolean
  wrapText?: boolean
  triggerClass?: string
  contentClass?: string
  maxWidth?: string
  wrapperClass?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTooltip',
  props: {
    text: { default: '' },
    position: { default: 'left' },
    showArrow: { type: Boolean, default: true },
    wrapText: { type: Boolean, default: false },
    triggerClass: { default: 'text-gray-400 dark:text-gray-500' },
    contentClass: { default: '' },
    maxWidth: { default: '' },
    wrapperClass: { default: 'inline' }
  },
  setup(__props: any) {

const props = __props

const positionClasses = computed(() => {
  switch (props.position) {
    case 'top':
      return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2'
    case 'bottom':
      return 'top-full left-1/2 transform -translate-x-1/2 mt-2'
    case 'left':
      return 'right-full top-1/2 transform -translate-y-1/2 mr-2'
    case 'right':
      return 'left-full top-1/2 transform -translate-y-1/2 ml-2'
    case 'top-left':
      return 'bottom-full right-0 mb-2'
    case 'top-right':
      return 'bottom-full left-0 mb-2'
    case 'bottom-left':
      return 'top-full right-0 mt-2'
    case 'bottom-right':
      return 'top-full left-0 mt-2'
    default:
      return 'right-full top-1/2 transform -translate-y-1/2 mr-2'
  }
})

const arrowClasses = computed(() => {
  switch (props.position) {
    case 'top':
      return 'top-full left-1/2 transform -translate-x-1/2 -mt-1 border-t-gray-900 dark:border-t-gray-700'
    case 'bottom':
      return 'bottom-full left-1/2 transform -translate-x-1/2 -mb-1 border-b-gray-900 dark:border-b-gray-700'
    case 'left':
      return 'right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 border-r-gray-900 dark:border-r-gray-700'
    case 'right':
      return 'left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 border-l-gray-900 dark:border-l-gray-700'
    case 'top-left':
      return 'top-full right-2 -mt-1 border-t-gray-900 dark:border-t-gray-700'
    case 'top-right':
      return 'top-full left-2 -mt-1 border-t-gray-900 dark:border-t-gray-700'
    case 'bottom-left':
      return 'bottom-full right-2 -mb-1 border-b-gray-900 dark:border-b-gray-700'
    case 'bottom-right':
      return 'bottom-full left-2 -mb-1 border-b-gray-900 dark:border-b-gray-700'
    default:
      return 'right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 border-r-gray-900 dark:border-r-gray-700'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['relative group', _ctx.wrapperClass])
  }, [
    _renderSlot(_ctx.$slots, "trigger", {}, () => [
      _createVNode(_unref(Info), {
        class: _normalizeClass(["w-4 h-4 cursor-help", _ctx.triggerClass])
      }, null, 8, ["class"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'absolute px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded-lg shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-10',
        positionClasses.value,
        _ctx.contentClass,
        { 'whitespace-nowrap': !_ctx.wrapText }
      ])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.text), 1)
      ]),
      (_ctx.showArrow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          'absolute border-4 border-transparent',
          arrowClasses.value
        ])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})